import LeadActionsPopoverWithDefaultActions from 'components/domain/lead/actions/LeadActionsPopoverWithDefaultActions';
import LeadCircle from 'components/domain/lead/status/LeadCircle';
import { Lead } from 'models/Leads';

const PipelineLeadListItemActiveStatusIndicator = ({
  lead,
}: {
  lead: Lead;
}) => {
  return (
    <LeadActionsPopoverWithDefaultActions lead={lead}>
      <LeadCircle lead={lead} />
    </LeadActionsPopoverWithDefaultActions>
  );
};

export default PipelineLeadListItemActiveStatusIndicator;
